import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { AuthCard } from "@/components/landing/AuthCard";

const HERO_IMG = "https://customer-assets-agu9un31.emergentagent.net/job_shot-matchup/artifacts/xmu31y3r_E073E870-2719-44C5-AB31-B0773B0FD372.png";

export default function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [mode, setMode] = useState(params.get("mode") === "register" ? "register" : "login");
  const next = params.get("tab") || "";

  useEffect(() => { if (user) navigate(next ? `/?tab=${next}` : "/", { replace: true }); }, [user, navigate, next]);

  return (
    <div className="dark min-h-screen bg-[#03050A] text-slate-200">
      <div className="relative flex min-h-screen items-center justify-center px-4 py-10">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_-10%,rgba(34,211,238,0.12),transparent_55%)]" />
        <div className="relative w-full max-w-md">
          <div className="mb-6 flex flex-col items-center text-center">
            <Link to="/" data-testid="login-home-link"><img src={HERO_IMG} alt="QSI HAT TRICK" className="h-28 w-auto rounded-lg object-contain drop-shadow-[0_0_30px_rgba(34,211,238,0.4)]" /></Link>
            <p className="mt-3 font-mono text-[10px] font-semibold uppercase tracking-[0.35em] text-lime-400">A QSI Product</p>
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-500">NHL Goal Target Intelligence</p>
          </div>
          <AuthCard mode={mode} setMode={setMode} nextTab={next} />
        </div>
      </div>
    </div>
  );
}
